import { render, staticRenderFns } from "./View.vue?vue&type=template&id=50b95a07"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b95a07')) {
      api.createRecord('50b95a07', component.options)
    } else {
      api.reload('50b95a07', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=50b95a07", function () {
      api.rerender('50b95a07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/InputGroup/View.vue"
export default component.exports